module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Spoon-6d537700fe1b6d9d8db42b1ef4f8d53c.svg";